import styled from 'styled-components';
import { TreeSelect as TreeSelectAntd } from 'antd';

const TreeSelect = styled(TreeSelectAntd)`
  .ant-select-selection-overflow-item-rest {
    visibility: hidden;
    width: 8px;
  }

  &.tag_render_account_card {
    .ant-select-selection-item {
      display: flex;
    }
    .component_accountCard {
      margin: auto 0;
      .component_account_card_description {
        display: none;
      }
      .ant-avatar {
        transform: scale(0.8);
      }
    }
  }
`;

export default TreeSelect;
